@if (showNoRecordsMessage()) {
  <div class="container-flex-center">
    <div class="info-hint mt-100 font-size-unset">
      {{ translations.norecords }}
    </div>
  </div>
  @if (canEdit()) {
    <div class="container-flex-center mt-30">
      {{ translations.clickaddbutton }}
    </div>
  }
} @else {
  @if (tagsService.get().length > 1) {
    <div class="container-flex">
      <app-tag-group
        [tags]="tagsService.get()"
        [isTagClickable]="true"
        (tagPressed)="onSelectedTag($event.value.toString())"
      />
    </div>
  }

  @for (resource of resources(); track $index) {
    @let type = resource.type;
    @let rowData = rowDataMap.get(type)();
    @let isLoading = isLoadingMap.get(type)();

    @if (resource.isRelated || rowData.length) {
      <article class="field-group-container">
        <div class="container-flex">
          <h4 class="no-vertical-margin">{{ resource.label }}</h4>

          @if (canEdit()) {
            <app-button
              class="add-btn"
              type="icon"
              size="medium"
              [tp]="translations.add"
              (pressed)="openReportsPanel(type)"
            >
              <mat-icon icon-medium-18>add</mat-icon>
            </app-button>
          }
        </div>

        @if (isLoading) {
          <app-loader containerClass="mt-30" />
        } @else {
          @if (!rowData.length) {
            <div class="font-size-14 mt-12">
              {{ translations.norecords }}
            </div>
          } @else {
            <ng-container
              *ngTemplateOutlet="table; context: { rowData, columnDefs: columnDefs() }"
            />
          }

          @let relatedRowData = relatedRowDataMap.get(type)();

          @if (canEdit() && resource.isRelated && relatedRowData.length) {
            <div class="container-flex mt-30">
              <h5 class="no-vertical-margin">
                {{ translations.suggested }}
                <mat-icon class="icon-20">wand_stars</mat-icon>
              </h5>

              <app-button
                class="add-btn"
                type="icon"
                [tp]="translations.addall"
                (pressed)="onAddAll(resource.type)"
              >
                <mat-icon icon-small>add</mat-icon>
              </app-button>
            </div>

            <ng-container
              *ngTemplateOutlet="
                table;
                context: { rowData: relatedRowData, columnDefs: relatedColumnDefs() }
              "
            />
          }
        }
      </article>
    }
  }
}

<ng-template #table let-rowData="rowData" let-columnDefs="columnDefs">
  <app-table
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [isLoading]="false"
    [isSearchEnabled]="false"
    [isRecordStateFilterEnabled]="false"
    [isFixedBottomPaginator]="false"
    [isPaginatorEnabled]="!overlay.contentRightSidePanel()"
  />
</ng-template>

<ng-template #reportsPanel>
  <app-risk-assessment-report-overlay-reports-panel
    [excludeReportIds]="reportIds()"
    [resourceType]="selectedResourceType()"
    (add)="onAdd($event)"
  />
</ng-template>

<ng-template #countryFlag let-country>
  <app-flag [country]="country" />
</ng-template>
